import { TaskFlow } from '../types/flow.js';

/**
 * Utility for mapping between Supabase Database rows and Frontend TaskFlow objects.
 * Centralizing this ensures that schema changes only need to be updated in one place.
 */

export const dbRowToFlow = (row: any): TaskFlow => ({
  id: row.id,
  teamId: row.team_id,
  name: row.name,
  description: row.description || undefined,
  isActive: row.is_active,
  currentStep: row.current_step,
  fromStateId: row.from_state_id,
  successStateId: row.success_state_id,
  createdAt: new Date(row.created_at),
});

export const mapFlowToDb = (updates: Partial<TaskFlow>): any => {
  const dbUpdates: any = {};
  
  if ('teamId' in updates) dbUpdates.team_id = updates.teamId;
  if ('name' in updates && updates.name !== undefined) dbUpdates.name = updates.name.trim();
  if ('description' in updates) dbUpdates.description = updates.description?.trim() || null;
  if ('isActive' in updates) dbUpdates.is_active = updates.isActive;
  if ('currentStep' in updates) dbUpdates.current_step = updates.currentStep;
  if ('fromStateId' in updates) dbUpdates.from_state_id = updates.fromStateId;
  if ('successStateId' in updates) dbUpdates.success_state_id = updates.successStateId;
  
  return dbUpdates;
};
